angular.module('app.filters').filter('photo', () => (type, id, photo, size, refresh) => {
    type = type || 'default';
    size = size || 'sm';
    refresh = refresh || false;

    switch (type) {
        case 'client':
            if (0 < photo) {
                return `/img/uploaded/clients/${id}-${size}.png${refresh ? `?${new Date().getTime()}` : ''}`;
            } else {
                return `/img/avatars/user-alt.png${refresh ? `?${new Date().getTime()}` : ''}`;
            }

        case 'user':
            if (0 < photo) {
                return `/img/uploaded/users/${id}-${size}.png${refresh ? `?${new Date().getTime()}` : ''}`;
            } else {
                return `/img/avatars/user-alt.png${refresh ? `?${new Date().getTime()}` : ''}`;
            }
    }

    return '/img/avatars/avatar_01_tn.png';
});
